import { newsletter } from './newsletter'
import { createInstagramFeed } from './instagram'
import { waitForElement } from '../base'

function moveAddFooterElements() {
    $('#footer .social-icon-list')
        .appendTo('.footer-bottom .container')
        .wrapAll('<div class="social-icons"></div>')

    $('.site-name > a').clone().prependTo('#footer .footer-rows')

    $('#signature').wrapAll('<div class="signature-wrapper"></div>')
    $('.signature-wrapper').append(`<a href="https://able.cz" class="able-logo"></a>`)

    $('#footer .contact-box ul').append(
        `<img src="/user/documents/able-images/vsevyhodne-footer-images.png" />`
    )
}

function copyFooterToLocalStorage() {
    const footer = $('#footer')
    if (footer.length) {
        const footerHTML = footer.prop('outerHTML')
        localStorage.setItem('FOOTER', footerHTML)
    }
}

function addFooterToCart() {
    if ($('.ordering-process').length) {
        const footer = localStorage.getItem('FOOTER')
        if (footer) {
            $('.overall-wrapper').append(footer)
        }
    }
}

export function initFooter() {
    newsletter()
    createInstagramFeed()
    moveAddFooterElements()
    copyFooterToLocalStorage()
    addFooterToCart()
}
